import { ReactElement } from 'react'
import { salesReportIcons } from '../icons'
import { Box, Field, Icon, Input, Label } from './styles'

interface DateTimeInputProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  onCommit?: () => void
  min?: string
  max?: string
  disabled?: boolean
  dense?: boolean
  invalid?: boolean
  describedBy?: string
}

export function DateTimeInput({
  id,
  label,
  value,
  onChange,
  onCommit,
  min,
  max,
  disabled = false,
  dense = false,
  invalid = false,
  describedBy,
}: DateTimeInputProps): ReactElement {
  return (
    <Field>
      <Label htmlFor={id} $dense={dense}>
        {label}
      </Label>
      <Box>
        <Input
          id={id}
          type="datetime-local"
          value={value}
          min={min}
          max={max}
          disabled={disabled}
          aria-invalid={invalid || undefined}
          aria-describedby={describedBy}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onCommit}
          onKeyDown={(event) => {
            if (event.key === 'Enter') onCommit?.()
          }}
        />
        <Icon src={salesReportIcons.calendarDays} alt="" width={16} height={16} aria-hidden="true" />
      </Box>
    </Field>
  )
}
